export default {
  APP_OPENED: 'APP_OPENED',
};
